import { render, staticRenderFns } from "./ModalCreateElement.vue?vue&type=template&id=70c2719d"
import script from "./ModalCreateElement.vue?vue&type=script&lang=js"
export * from "./ModalCreateElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports